import { render, staticRenderFns } from "./InputPhone.vue?vue&type=template&id=f549bdd2&lang=html&"
import script from "./InputPhone.vue?vue&type=script&lang=js&"
export * from "./InputPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports